<template>
  <div id="app">
    <app-header></app-header>
    <router-view />

    <notifications />
    <app-footer></app-footer>
  </div>
</template>
<script>
import appHeader from '@/app/components/appHeader'
import appFooter from '@/app/components/appFooter'
// import { footerRoutesRef } from '@/admin/firebase_config'

export default {
  name: 'App',
  components: {
    appHeader,
    appFooter
  }
}

</script>
<style lang="scss">
html,
body,
#admin {
  font-family: sans-serif;
  background-color: #f1f1f1;
  height: 100%;
  width: 100%;
  margin: 0px;
  padding: 0px;
  .bulma {
    // We are not changing anything currently. If need to customize then import bulma saas.
    @import '../node_modules/bulma/css/bulma.css';
    * {
      box-sizing: border-box;
    }
  }
}
</style>
